import React, {useEffect} from 'react';
import { useDispatch} from 'react-redux'
import { bindActionCreators } from 'redux'
import { CardContainer } from '../../Components/Card/Card';
import ActiveFlags from "../../Components/FeatureToggles/ActiveFlags";
import FlagSelection from "../../Components/FeatureToggles/FlagSelection";
import settingsActionsImp from "../../Actions/settingsActions";
import useEditFeatureFlag from "../../Hooks/FeatureFlags/useEditFeatureFlag";
function FeatureFlagsContainer({ }) {
    const { enabledFeatureFlags, backendFeatureFlags, externalClients, managedTeams, users} = useEditFeatureFlag();
    const dispatch = useDispatch();
    const settingsActions = bindActionCreators(settingsActionsImp, dispatch);
    
    useEffect(() => {
        if (!users || !managedTeams || !externalClients)
            settingsActions.getAllEditRoleModel();
        if (!backendFeatureFlags)
            settingsActions.getAllFeatureFlags();
        if (!enabledFeatureFlags)
            settingsActions.getEnabledFeatureFlags();
    }, [])
    
    return <CardContainer>
        <FlagSelection />
        <ActiveFlags />
    </CardContainer>
}

export default FeatureFlagsContainer;